module.exports = __webpack_public_path__ + "img/9.88e1e070.png";